export const setOTHERPLGR = "setOTHERPLGR";
